import { Skeleton } from '@mui/material'
import { Card, ValueSunburstWithTable, ValueSunburstWithTableLoading } from 'components/core-v2'

import { plural } from '../../../../utilities/plural'
import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { formatData } from './formatData'

export const PortfolioSunburstChart = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()

  if (isLoading || isFetching) {
    return (
      <Card.Wrapper>
        <Card.Header>
          <Skeleton height="21px" variant="rectangular" width="160px" />
        </Card.Header>
        <ValueSunburstWithTableLoading />
      </Card.Wrapper>
    )
  }

  const { portfolios } = data

  const count =
    portfolios.selfSelect.portfolios.length +
    portfolios.model.portfolios.length +
    portfolios.fundOfFunds.portfolios.length
  const title = `${count} ${plural('Portfolio type', count)}`

  const formattedData = formatData(portfolios)

  return (
    <Card.Wrapper>
      <Card.Header title={title} />
      <ValueSunburstWithTable data={formattedData} seriesName="Portfolios" />
    </Card.Wrapper>
  )
}
